/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import { Column } from "../../../layout/flexbox";
import { COOL_GREY } from "../../../styles/colors";
import React from "react";

const dividerCss = css`
  height: 2px;
  width: 100%;
  background-color: ${COOL_GREY};
  margin-top: 10px;
  margin-bottom: 30px;
`;

const Divider = () => <div css={dividerCss} />;

type Props = {
  header: React.ReactNode;
  rules: React.ReactNode;
  /** Grow to fit content instead of the fixed modal height (used in the drawer). */
  autoHeight?: boolean;
  rootCss?: SerializedStyles;
};

export function LiftAccessRuleSetEditorLayout({
  header,
  rules,
  autoHeight,
  rootCss,
}: Props) {
  return (
    <Column
      rootCss={css`
        ${rootCss};
        height: ${autoHeight ? "auto" : "750px"};
        display: flex;
        flex-direction: column;
      `}
    >
      {header}
      <Divider />
      {rules}
    </Column>
  );
}
